import { AxiosPromise } from 'axios';

import {
  ActiveUsersResponse,
  ActiveUsersTrendResponse,
  AnalyticsRangeParams,
  AnalyticsSeriesResponse,
  AnalyticsVaccinationsParams,
  GeographyResponse,
  LanguagesResponse,
  ProfileFillRateResponse,
  RegistrationFunnelResponse,
  UsersCountSeriesResponse,
} from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/analytics';

const authHeader = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
});

export const getRegistrations = async (params: AnalyticsRangeParams = {}): AxiosPromise<AnalyticsSeriesResponse> =>
  apiInstance.get(`${BASE_URL}/registrations`, { params, headers: authHeader() });

export const getUsersCount = async (params: AnalyticsRangeParams = {}): AxiosPromise<UsersCountSeriesResponse> =>
  apiInstance.get(`${BASE_URL}/users-count`, { params, headers: authHeader() });

export const getVaccinations = async (
  params: AnalyticsVaccinationsParams = {},
): AxiosPromise<AnalyticsSeriesResponse> =>
  apiInstance.get(`${BASE_URL}/vaccinations`, { params, headers: authHeader() });

export const getActiveUsers = async (): AxiosPromise<ActiveUsersResponse> =>
  apiInstance.get(`${BASE_URL}/active-users`, { headers: authHeader() });

export const getActiveUsersTrend = async (params: AnalyticsRangeParams = {}): AxiosPromise<ActiveUsersTrendResponse> =>
  apiInstance.get(`${BASE_URL}/active-users-trend`, { params, headers: authHeader() });

export const getGeography = async (): AxiosPromise<GeographyResponse> =>
  apiInstance.get(`${BASE_URL}/geography`, { headers: authHeader() });

export const getProfileFillRate = async (): AxiosPromise<ProfileFillRateResponse> =>
  apiInstance.get(`${BASE_URL}/profile-fill-rate`, { headers: authHeader() });

export const getLanguages = async (): AxiosPromise<LanguagesResponse> =>
  apiInstance.get(`${BASE_URL}/languages`, { headers: authHeader() });

export const getRegistrationFunnel = async (): AxiosPromise<RegistrationFunnelResponse> =>
  apiInstance.get(`${BASE_URL}/registration-funnel`, { headers: authHeader() });
